/* istanbul ignore file */
import { getVisibility } from 'framework/utils';
import { useShowContext } from 'framework/show';

interface FieldGroupProps {
  isVisible: TypeOrFunction<boolean> | ((data: any) => boolean);
  children: React.ReactElement | React.ReactElement[];
}

const FieldGroup = ({ isVisible, children }: FieldGroupProps) => {
  const { data } = useShowContext();

  const isSectionsVisible = getVisibility(data, isVisible as any);

  return isSectionsVisible && children;
};

export default FieldGroup;
